import {AfterViewInit, Component} from '@angular/core';
import {ContainerComponent} from '../../container/container.component';
import {GtmEventsService} from '../../../shared/gtm-events.service';
import {CookieConsentService} from '../../../shared/cookie-consent.service';

@Component({
  selector: 'app-privacy-policy',
  imports: [ContainerComponent],
  standalone: true,
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent implements AfterViewInit {

  constructor(private _gtmEventsService: GtmEventsService, private _cookieConsentService: CookieConsentService) {
  }

  ngAfterViewInit(): void {
    this._gtmEventsService.pushPageView('Privacy Policy');
  }

  openCookieConsentModal() {
    this._cookieConsentService.showPreferences();
  }
}
